var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('HomeHeader',{on:{"login":_vm.handleLogin,"enter-bar":_vm.handleEnterBar}}):_vm._e(),_c('keep-alive',[_c('router-view')],1),_c('LoginDialog',{attrs:{"visible":_vm.showLoginDialog},on:{"close":_vm.handleCloseDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }